import React from 'react';
import PlaceForm from '../../components/organism/PlaceForm';
import { useLocation, useParams } from 'react-router-dom';
import { PlaceTypeEnum } from '../../enums/PlaceTypeEnum';

type LocationState = { plan?: { placeType: PlaceTypeEnum } | null } | null;

export default function PlaceEdit() {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const placeId = Number(id);
  const selectedPlan = (location.state as LocationState)?.plan ?? null;

  return <PlaceForm mode="edit" placeId={placeId} selectedPlan={selectedPlan} />;
}
